import React from "react";
import ReactDOM from "react-dom/client";

import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate
} from "react-router-dom";

import {
  Security,
  LoginCallback
} from "@okta/okta-react";

import { oktaAuth } from "./OktaAuth";
import App from "./App";


function AppSecurity() {

  const navigate = useNavigate();

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {

    navigate(originalUri || "/");

  };

  return (
    <Security
      oktaAuth={oktaAuth}
      restoreOriginalUri={restoreOriginalUri}
    >

      <Routes>

        <Route
          path="/login/callback"
          element={<LoginCallback />}
        />

        <Route
          path="/*"
          element={<App />}
        />

      </Routes>

    </Security>
  );
}


const root = ReactDOM.createRoot(
  document.getElementById("root")
);


root.render(

  <BrowserRouter>

    <AppSecurity />

  </BrowserRouter>

);